// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__FmQOS","section-1":"About_section-1__0cRqF","content":"About_content__wEXCr","section-2":"About_section-2__dRAfw"};